module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_fleisher_sm-e6d17d9dfbe09825aaa098b3c6740f91.png";